import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";

import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { HouseholdEndpoints } from "src/containers/household/constants/endpoints";

@injectable()
export class HouseholdRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getBuildings(userIdentity: string, policyId: number): Observable<object[]> {
        const endpoint = HouseholdRepository.getBuildingsURL(
            userIdentity,
            policyId
        );
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity,
            "MEP"
        );
        return this.http.getJSON<object[]>(endpoint, {
            isPublicRequest: false,
            params: { "system-code": "GW" },
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    private static getBuildingsURL(
        userIdentity: string,
        policyId: number
    ): string {
        const templateUrl = HouseholdEndpoints.GetBuildings;
        return templateUrl
            .replace(":userIdentity", userIdentity)
            .replace(":policyId", policyId.toString());
    }
}
